import { z } from 'zod'

const ingestionJobSchema = z.object({
  id: z.number(),
  name: z.string(),
  account_id: z.string(),
  created_at: z.string(),
  status: z.string(),
  requested_start_cursor: z.string().nullish(),
  actual_start_cursor: z.string().nullish(),
  end_cursor: z.string().nullish(),
  integration: z.string(),
  integration_name: z.string(),
  full_sync_id: z.string().nullish(),
  status_details: z
    .object({
      transaction_count: z.number().default(0),
      successful_transaction_count: z.number().default(0),
      skipped_transaction_count: z.number().default(0),
      failed_transaction_count: z.number().default(0),
      last_txn_date: z.string().nullish(),
    })
    .default({})
    .nullable(),
})
export type IngestionJob = z.infer<typeof ingestionJobSchema>

export const fetchIngestionJobs = z.object({
  result: z.array(ingestionJobSchema),
})
